var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { SAIcon, SAIcons, SAIconSize } from '../icon';
var SAPaginationStateChange;
(function (SAPaginationStateChange) {
    SAPaginationStateChange[SAPaginationStateChange["first"] = 0] = "first";
    SAPaginationStateChange[SAPaginationStateChange["decrement"] = 1] = "decrement";
    SAPaginationStateChange[SAPaginationStateChange["increment"] = 2] = "increment";
    SAPaginationStateChange[SAPaginationStateChange["last"] = 3] = "last";
})(SAPaginationStateChange || (SAPaginationStateChange = {}));
var PaginationContainer = styled.nav(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function () {
    return "\n      display: inline-flex;\n    ";
});
// TODO: Fix issue requirng this any type...
var PaginationButton = styled.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (props) {
    var theme = props.theme;
    return "\n      color: inherit;\n      font: inherit;\n      cursor: pointer;\n      outline: inherit;\n      background: " + (theme === null || theme === void 0 ? void 0 : theme.color.background.background) + ";\n      border: 1px solid " + (theme === null || theme === void 0 ? void 0 : theme.separator.line.color) + ";\n      border-radius: " + (theme === null || theme === void 0 ? void 0 : theme.size.radius.small) + ";\n      line-height: 0;\n      padding: " + (theme === null || theme === void 0 ? void 0 : theme.size.spacer.xs) + ";\n      \n      &:disabled {\n        color: " + (theme === null || theme === void 0 ? void 0 : theme.separator.line.color) + ";\n        cursor: not-allowed;\n\n        svg {\n          opacity: 0.2;\n        }\n      }\n    ";
});
// TODO: Fix issue requirng this any type...
var PaginationList = styled.ul(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function () {
    return "\n      align-items: center;\n      display: flex;\n      list-style: none;\n    ";
});
// TODO: Fix issue requirng this any type...
var PaginationListItem = styled.li(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (props) {
    var theme = props.theme;
    return "\n      display: inline-block;\n      margin-left: " + (theme === null || theme === void 0 ? void 0 : theme.size.spacer.xs) + ";\n\n      &:first-child {\n        margin-left: 0;\n      }\n    ";
});
// TODO: Fix issue requirng this any type...
var CurrentPageIndicator = styled.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (props) {
    var theme = props.theme;
    return "\n      align-items: center;\n      background: " + (theme === null || theme === void 0 ? void 0 : theme.color.secondary.background) + ";\n      border-radius: " + (theme === null || theme === void 0 ? void 0 : theme.size.radius.round) + ";\n      color: " + (theme === null || theme === void 0 ? void 0 : theme.color.secondary.foreground) + ";\n      display: inline-flex;\n      font-size: " + (theme === null || theme === void 0 ? void 0 : theme.font.primary.size.xl) + ";\n      font-weight: " + (theme === null || theme === void 0 ? void 0 : theme.font.primary.weight.bold) + ";\n      height: 45px;\n      justify-content: center;\n      line-height: " + (theme === null || theme === void 0 ? void 0 : theme.font.primary.size.xl) + ";\n      margin-left: calc(" + (theme === null || theme === void 0 ? void 0 : theme.size.spacer.medium) + " - " + (theme === null || theme === void 0 ? void 0 : theme.size.spacer.xs) + ");\n      width: 45px;\n    ";
});
// TODO: Fix issue requirng this any type...
var PaginationInfo = styled.span(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (props) {
    var theme = props.theme;
    return "\n      font-size: " + (theme === null || theme === void 0 ? void 0 : theme.font.primary.size.large) + ";\n      margin-left: " + (theme === null || theme === void 0 ? void 0 : theme.size.spacer.xs) + ";\n\n      &:last-child {\n        margin-right: calc(" + (theme === null || theme === void 0 ? void 0 : theme.size.spacer.medium) + " - " + (theme === null || theme === void 0 ? void 0 : theme.size.spacer.xs) + ");\n      }\n    ";
});
// TODO: Fix the weierd if block below. The onChange prop seems
// to be throwing off the Jest code coverage check for some reason.
// This is the only way I could get it to work.
function changePage(props, stateChange) {
    var currentPageIndex = props.currentPageIndex, itemsPerPage = props.itemsPerPage, onChange = props.onChange, totalItems = props.totalItems;
    if (stateChange === SAPaginationStateChange.first) {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        onChange && onChange(0);
    }
    else if (stateChange === SAPaginationStateChange.decrement) {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        onChange && onChange(currentPageIndex - 1);
    }
    else if (stateChange === SAPaginationStateChange.increment) {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        onChange && onChange(currentPageIndex + 1);
        // SAPaginationStateChange.last
    }
    else {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        onChange && onChange(Math.ceil(totalItems / itemsPerPage) - 1);
    }
}
// TODO: Make aria label configurable.
export function SAPagination(props) {
    var currentPageIndex = props.currentPageIndex, itemsPerPage = props.itemsPerPage, totalItems = props.totalItems, children = props.children, onChange = props.onChange, theme = props.theme, additionalProps = __rest(props, ["currentPageIndex", "itemsPerPage", "totalItems", "children", "onChange", "theme"]);
    var currentPage = currentPageIndex + 1;
    var totalPages = Math.ceil(totalItems / itemsPerPage);
    if (totalPages > 1) {
        return (React.createElement(PaginationContainer, __assign({ role: "navigation", "aria-label": "Pagination Navigation" }, additionalProps),
            React.createElement(PaginationList, null,
                React.createElement(PaginationListItem, null,
                    React.createElement(PaginationButton, { type: "button", onClick: function () { return changePage(props, SAPaginationStateChange.first); }, disabled: currentPage === 1, "aria-label": "Go To First Grouping" },
                        React.createElement(SAIcon, { icon: SAIcons.chevronsLeft, size: SAIconSize.small, colorVariant: "dark" }))),
                React.createElement(PaginationListItem, null,
                    React.createElement(PaginationButton, { type: "button", onClick: function () { return changePage(props, SAPaginationStateChange.decrement); }, disabled: currentPage === 1, "aria-label": "Go To Previous Grouping" },
                        React.createElement(SAIcon, { icon: SAIcons.chevronLeft, size: SAIconSize.small, colorVariant: "dark" }))),
                React.createElement(PaginationListItem, { "aria-label": "Current Grouping" },
                    React.createElement(CurrentPageIndicator, { "aria-current": "true" }, currentPage),
                    React.createElement(PaginationInfo, null, "of"),
                    React.createElement(PaginationInfo, null, totalPages)),
                React.createElement(PaginationListItem, null,
                    React.createElement(PaginationButton, { type: "button", onClick: function () { return changePage(props, SAPaginationStateChange.increment); }, disabled: currentPage === totalPages, "aria-label": "Go To Next Grouping" },
                        React.createElement(SAIcon, { icon: SAIcons.chevronRight, size: SAIconSize.small, colorVariant: "dark" }))),
                React.createElement(PaginationListItem, null,
                    React.createElement(PaginationButton, { type: "button", onClick: function () { return changePage(props, SAPaginationStateChange.last); }, disabled: currentPage === totalPages, "aria-label": "Go To Last Grouping" },
                        React.createElement(SAIcon, { icon: SAIcons.chevronsRight, size: SAIconSize.small, colorVariant: "dark" }))))));
    }
    return null;
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=pagination.component.js.map